/**
 * Document-related strings.
 */
import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Icons from '../ui/IconButton/Icons';


export default {
    d_title: 'Notes and Attachments',
    h_title: <div>
        <p>The <b>Notes and Attachments</b> section enables you to create notes or
            upload files from your computer.</p>
        <div>There are two types of notes:
            <ul>
                <li><b>Text Notes</b> have no formatting, and are great for taking rapid notes on a phone call.</li>
                <li><b>Fancy Notes</b> have rich formatting like MS Word, and are great for creating highly
                    structured notes.
                </li>
            </ul>
        </div>
        <div>There are three ways to add attachments.
            <ul>
                <li>Click on the <b><FontAwesomeIcon icon={Icons.ATTACHMENT.reactIcon}/> File(s)</b> button, then
                click on the <b>Select...</b> button to open a file chooser dialog, then choose the file and click OK.
                </li>
                <li>Click on the <b><FontAwesomeIcon icon={Icons.ATTACHMENT.reactIcon}/> File(s)</b> button, then
                    drag and drop files from your computer onto the <b>Drop File(s) Here</b> area.
                </li>
                <li>Drag files directly on to the <b>Notes and Attachments</b> box.</li>
            </ul>
        </div>
        <p>Notes or attachments can be downloaded using the Download <FontAwesomeIcon
            icon={Icons.DOWNLOAD.reactIcon}/> button.</p>
    </div>,

    d_portal_title: 'Documents: Drag-and-Drop or use File(s) to upload',
    h_portal_title: '<div><p>This is where you will upload documents requested by us.</p><p>This is also where you will find documents created by us for your case.</p><p>You can drag multiple files into the Documents box, or you can add files individually using the File(s) button.</p></div>',

    d_documentHidden: 'This document is hidden in the client portal',

    d_makeVisible: 'Make visible in client portal',

    d_download: 'Download this file to your computer',

    d_private: 'This document is hidden from the client in the client portal',

    d_excludeFromCaseFile: 'Exclude from Case File',

    d_includeInCaseFile: 'Include in Case File',

    d_files: 'File(s)',
    h_files: 'Upload a file to the server',

    d_note: 'Note',
    h_note: 'Create a new plain text note (no formatting)',

    d_fancy: 'Fancy',
    h_fancy: 'Create a new rich text note (similar to Microsoft Word)'
};